export const busRecordStatus = [
  { key: "O", badgeColor: "success" },
  { key: "C", badgeColor: "danger" },
];

export const busRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const busModeList = {
  VIEW_BUS_DETAIL: "VIEW_BUS_DETAIL",
  EDIT_BUS_DETAIL: "EDIT_BUS_DETAIL",
};

export const getInitBusParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    columnFilterKeep: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "hub,maker,checker",
  };
};
